<div class="modal-header justify-content-center mdlb-sum-modal-header">
  <h1>{{diy}}</h1>
  <button aria-hidden="true" class="close" data-dismiss="modal" type="button" (click)="close()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col col-12 align-content-center">
      <img src="{{imgSrc}}" class="trayImg">
    </div>
  </div>

</div>
